<template>
  <div class="list-box fadeIn">
    <img class="top-title" :src="titleImg">
    <div class="unit-scroll">
      <div class="unit-box">
        <div class="unit-item" :class="{ finish_unit: item.isFinished, preFinished: item.preFinished }"
          v-for="(item, i) in intList" :key="i" @click="chooseItem(item)">
          <div class="unit-cover-box">
            <img class="unit-cover" :src="item.Cover">
          </div>
          <div class="unit-info">
            <div class="unit-name">{{ item.InductionName }}</div>
            <div class="unit-describe">{{ item.Description }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  components: {},
  name: "flag_list",
  props: {
    classInfo: Object,
    intList: Array
  },
  data() {
    return {
      titleImg: require('@/assets/images/list/card/title.png'),
    }
  },
  async mounted() {
    let covers = [];
    for (let i = 0; i < 4; i++) {
      let cover = require(`@/assets/images/list/card/${i}.png`);
      covers.push(cover);
    }

    this.intList.forEach((int, i) => {
      if (!int.Cover) {
        int.Cover = covers[i % 4];
      }
    })
  },
  methods: {
    //选择其中一个
    chooseItem(item) {
      if (!item.preFinished && item.preIntName) return this.$message.warning(`请先完成前置单元《${item.preIntName}》，再开始此单元`);
      this.$emit('chooseItem', item)
    }
  },
  //beforeUnmount() {},
}
</script>

<style scoped lang="scss">
@import "./card-list.scss";
</style>